import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-bnb-gallery/dist/style.css";
import "leaflet/dist/leaflet.css";
import "../assets/css/front/line-awesome.min.css";

import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	defaults: "2026-01-30",
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	// <React.StrictMode>
	<PostHogProvider client={posthog}>
		<PostHogErrorBoundary>
			<App />
		</PostHogErrorBoundary>
	</PostHogProvider>,
	// </React.StrictMode>
);
